import React, { useCallback, useMemo } from 'react';

import { groupBy, keys, sortBy } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import { organizationGuidSel } from '@context';
import { useGetBasicReports } from '@modules/reports/basicReports/duck/hooks';
import { Spin, T } from '@modules/shared/components';
import { openBasicReport } from '@utils';

import { SingleReport } from '../../common';
import { openSelectYouthModal } from '../duck';
import styles from './BasicReports.less';
import SelectYouthModal from './SelectYouthModal';

const BasicReports = () => {
  const dispatch = useDispatch();
  const organizationGuid = useSelector(organizationGuidSel);
  const { reports, loading } = useGetBasicReports();

  const handleClick = useCallback(
    report => () => {
      const { ReportURI, isIndividual, reportCode } = report;
      isIndividual
        ? dispatch(openSelectYouthModal(reportCode))
        : openBasicReport(ReportURI, { organizationGuid });
    },
    [dispatch, organizationGuid],
  );

  const groupedReports = useMemo(
    () => groupBy(reports, 'ReportGroupName'),
    [reports],
  );

  const reportsList = useMemo(
    () =>
      sortBy(keys(groupedReports), [
        str => (str === '' ? 1 : 0),
        str => str.toLowerCase(),
      ]).map(reportGroupKey => (
        <div key={`groupedBasicReports_${reportGroupKey}`}>
          <div className={styles.title}>
            <T size="4" noMargin>
              {reportGroupKey}
            </T>
          </div>
          {groupedReports[reportGroupKey].map((report, index) => (
            <SingleReport
              key={report.id}
              name={report.ReportName}
              report={report}
              noDivider={index + 1 === groupedReports[reportGroupKey].length}
              onClick={handleClick(report)}
            />
          ))}
        </div>
      )),
    [groupedReports, handleClick],
  );

  return (
    <div className={styles.content}>
      <SelectYouthModal />
      <div className={styles.reportsList}>
        <Spin spinning={loading}>{reportsList}</Spin>
      </div>
    </div>
  );
};

export default BasicReports;
